export default {
	View: 1,
	Save: 2,
	SaveAdd: 3,
	Delete: 4,
	Complete: 5,
	SendBack: 6,
	CancelComplete: 7,
	Change: 8,
	Add: 9,
};